<template>
  <div class="app-main__inner">
    <TituloComponent
      icono-titulo="fas fa-pencil-alt"
      texto-titulo="Editar Obra Social"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarObraSocial()">
          <float-label label="Código:" clase>
            <input
              v-model="obraSocial.codigo"
              id="codigo"
              placeholder="Ingresar un código..."
              type="text"
              class="form-control"
              :class="enviado && !$v.obraSocial.codigo.required ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.obraSocial.codigo.required"
              >
                Debe ingresar un código
              </div>
            </template>
          </float-label>
          <float-label label="Codigo AFIP:" clase>
            <input
              v-model="obraSocial.codigo_afip"
              id="codigo_afip"
              placeholder="Ingresar nomenclatura de AFIP."
              type="text"
              class="form-control"
              :class="enviado && !$v.obraSocial.codigo_afip.required ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.obraSocial.codigo_afip.required"
              >
                Debe ingresar un código
              </div>
            </template>
          </float-label>
          <float-label label="Descripción:" clase>
            <input
              v-model="obraSocial.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="enviado && !$v.obraSocial.descripcion.required ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.obraSocial.descripcion.required"
              >
                Debe ingresar una descripción
              </div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";
import ObraSocial from "@/models/obraSocial";
export default {
  name: "EditarObraSocial",
  components: {
    TituloComponent,
    FloatLabel,
  },
  data() {
    return {
      obraSocial: new ObraSocial(null, "", "", ""),
      loading: false,
      enviado: false,
    };
  },
  validations: {
    obraSocial: {
      codigo_afip: { required },
      codigo: { required },
      descripcion: { required },
    },
  },
  mounted() {
    this.obraSocial.id = this.$route.params.id;
    this.getObraSocial();
  },
  methods: {
    getObraSocial() {
      this.loading = true;
      axios
        .get("obrasocial/" + this.obraSocial.id)
        .then((res) => {
          console.log(res.data);
          if (res.data.success) {
            this.obraSocial = res.data.obrasocial;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado Obras Sociales.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarObraSocial() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .put("/obrasocial/" + this.obraSocial.id, this.obraSocial)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.obrasocial.descripcion} se editó con éxito.`,
            });
            this.$router.push({ name: "ListarObraSocial" });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
